import { inject, Injectable } from '@angular/core';
import { AcceptanceDbService } from './acceptance-db.service';
import { AcceptanceExtended } from './acceptance.models';

/**
 * Servicio de Base de datos para el manejo de Aceptacion de terminos
 */
@Injectable({ providedIn: 'root' })
export class AcceptanceService {

  private acceptanceDbService = inject(AcceptanceDbService);

  upsertAcceptanceRecord(data: AcceptanceExtended): Promise<string> {
    return this.acceptanceDbService.upsert(data);
  }
}
